import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Dotcom2024Service } from '../dotcom2024.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { MyharrellsService } from '../myharrells.service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';


@Component({
  selector: 'app-myharrellsaccountsetup',
  standalone: true,
  imports: [FormsModule, CommonModule, NgxMaskDirective, NgxMaskPipe],
  providers: [provideNgxMask()],
  templateUrl: './myharrellsaccountsetup.component.html',
  styleUrl: './myharrellsaccountsetup.component.css'
})
export class MyharrellsaccountsetupComponent {

  appDomainURL: string = environment.appDomainURL;
  baseFilePath: string = environment.baseImagesFilePathBlobStorage;
  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/AccountSetup/";
  employeePhotosImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Employee-Photos/";
  filePaths: string = environment.azureBlobStorageURL + environment.baseFilesPathBlobStorage + "/";


  sortDir: string = "asc";

  imagefilePath = this.appDomainURL + this.baseFilePath + "/searchicon.jpg";


  email: string = "";
  lastRegistrationStatus: string = "";
  name: string = "";
  password: string = "";
  confirmPassword: string = "";
  phone: string = "";
  title: string = "";
  forceActive: boolean = false;
  customerId: string = "";
  zipCode: string = "";
  useZipContent: boolean = false;
  zipRepSelected: boolean = false;

  verifiedRep: any = {};
  assocatedMyHarrellsUsers: any[] = [];
  zipReps: any[] = [];
  selectedZipRep: any = {};
  companyName: string = "";
  manualCompanyNameEntered: string = "";
  selectedZipCustNmbr: string = "";
  validatedCustomer: boolean = false;



  displayLoginFailure: boolean = false;
  displaySuccessAlert: boolean = false;
  failureText: string = "";
  successText: string = "";



  constructor(public myHarrellsService: MyharrellsService, public dotComService: Dotcom2024Service, public router: Router, public route: ActivatedRoute) { }

  ngOnInit() {

    //get value from session storage for loginStage if there is one 
    //this session variable is only set when user is in the middle of the accout setup process and returning to the login
    //force them to complete the process first 
    this.myHarrellsService.stage = sessionStorage.getItem('loginStage');


    if (this.myHarrellsService.stage == null) {
      //the are new to the login process so start them at the beginning    
      //this.myHarrellsService.stage = "CustomerQuestion";


      //we are no longer prompting to see if they are a customer - 4/9/25 
      this.myHarrellsService.stage = "ClientInfo";
    }
    else {
      //session variable was set so they are returning to the login process after starting it

      this.myHarrellsService.GetUserByEmail(this.myHarrellsService.loggedInMyHarrellsUser.Email).subscribe((data: any) => {
        if (data.length > 0) {
          this.email = data[0].Email;
          this.password = data[0].Password;
          this.title = data[0].Title;
          this.name = data[0].Name;
          this.phone = data[0].Phone;
          this.forceActive = data[0].Active;


          //if they are waiting on the rep to approve and have completed the personal info part and customer info part, show the processing screen with rep info
          //i think the stage set in the session variable (loginStage) will be 'ProcessingRequest'
          if (this.myHarrellsService.stage == 'ProcessingRequest') {
            //they went to the login screen first but waiting on rep approval
            //it forwards them here so they can be notified of the approval process
            this.myHarrellsService.GetCustomerByCustNmbr(this.myHarrellsService.loggedInMyHarrellsUser.Company).subscribe((data: any) => {
              if (data.length > 0) {
                this.selectedZipRep = data[0];
                //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
                this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.selectedZipRep.Id + ".jpg", (exists) => {
                  if (exists) {
                    // Success code
                    this.selectedZipRep.empPhoto = this.employeePhotosImagePaths + this.selectedZipRep.Id + ".jpg";
                  } else {
                    // Fail code
                    this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.selectedZipRep.Id + ".png", (exists) => {
                      if (exists) {
                        // Success code
                        this.selectedZipRep.empPhoto = this.employeePhotosImagePaths + this.selectedZipRep.Id + ".png";
                      } else {
                        // Fail code - use default
                        this.selectedZipRep.empPhoto = this.baseImagePaths + "harrellsh.png"
                      }
                    })
                  }
                });
              }
            })
          }

        }
      })


      // this.title = this.myHarrellsService.loggedInMyHarrellsUser.Title;
      // this.name = this.myHarrellsService.loggedInMyHarrellsUser.Name;
      // this.email = this.myHarrellsService.loggedInMyHarrellsUser.Email;
      // this.phone = this.myHarrellsService.loggedInMyHarrellsUser.Phone;

    }
  }

  SubmitSetupClicked() {
    this.HideFailureAlert

    if (this.email.trim() == "" || this.password.trim() == "" || this.name.trim() == "") {
      this.failureText = "Required field(s) not entered. Please check your entries and try again.";
      this.displayLoginFailure = true;
      return;
    }

    if (this.password != this.confirmPassword) {
      this.failureText = "Passwords do not match. Please check your entries and try again.";
      this.displayLoginFailure = true;
      return;
    }

    if (this.phone.length > 0 && this.phone.length < 10) {
      this.failureText = "Phone number is invalid. Please check your entry and try again.";
      this.displayLoginFailure = true;
      return;
    }


    this.myHarrellsService.RegisterNewUser(this.email, this.password, this.name, this.phone, this.title, this.forceActive).subscribe((data: any) => {
      if (data == "success") {
        //their personal info is logged into the tables, now display the company info for the to fill in 
        this.myHarrellsService.stage = "CustomerInfo"
        this.validatedCustomer = false; //turn it off for the next screen
      }
      else {
        this.failureText = "Registration failed. " + data;
        this.displayLoginFailure = true;
      }
    })

  }
  HelpFindCustomerNmbr() {
    this.myHarrellsService.stage = "FindCustomerNmbr"
  }


  CustomerYesClicked() {
    this.myHarrellsService.stage = "ClientInfo"
  }

  CustomerNoClicked() {
    this.myHarrellsService.stage = "NotExistingCustomer"
  }

  HideSuccessAlert() {
    this.displaySuccessAlert = false;
    this.successText = "";
  }

  HideFailureAlert() {
    this.useZipContent = false;
    this.displayLoginFailure = false;
    this.failureText = "";
  }

  CancelCustNmbr() {
  }


  NotACustomer() {
    this.myHarrellsService.stage = "NotExistingCustomer";
  }

  VerifyClicked() {
    //get rep info for the customer id passed 
    this.HideFailureAlert();
    this.companyName = "";
    this.verifiedRep = {};
    this.assocatedMyHarrellsUsers = [];

    this.myHarrellsService.GetCustomerByCustNmbr(this.customerId).subscribe((data: any) => {
      if (data.length > 0) {
        this.validatedCustomer = true;
        this.verifiedRep = data[0];
        this.companyName = this.verifiedRep.CustomerName.trim();
        // this.verifiedRep.SalesRepEmail = this.verifiedRep.SalesRepEmail.replace('@', '&#64');

        //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
        this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.verifiedRep.Id + ".jpg", (exists) => {
          if (exists) {
            // Success code
            this.verifiedRep.empPhoto = this.employeePhotosImagePaths + this.verifiedRep.Id + ".jpg";
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.verifiedRep.Id + ".png", (exists) => {
              if (exists) {
                // Success code
                this.verifiedRep.empPhoto = this.employeePhotosImagePaths + this.verifiedRep.Id + ".png";
              } else {
                // Fail code - use default
                this.verifiedRep.empPhoto = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });
        //get the existing myharrells users tied to this customer 
        this.assocatedMyHarrellsUsers = [];
        this.myHarrellsService.GetUsersByCustNmbr(this.customerId).subscribe((data: any) => {
          this.assocatedMyHarrellsUsers = data;
        })

      }
      else {
        this.failureText = "Customer number not found.  Please try again or use the 'Help me find this' option.";
        this.displayLoginFailure = true;
        this.companyName = "";
        this.verifiedRep = {};
        this.assocatedMyHarrellsUsers = [];
        this.validatedCustomer = false;
      }
    })

    //get the existing myharrells users tied to this customer 


  }

  ValidateZipCodeClicked() {
    this.selectedZipCustNmbr = "";
    this.zipReps = [];
    this.zipRepSelected = false;
    this.HideFailureAlert()

    this.myHarrellsService.GetRepInfoByZipcode(this.zipCode).subscribe((data: any) => {
      if (data.length > 0) {
        for (let index = 0; index < data.length; index++) {
          const element = data[index];


          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".jpg", (exists) => {
            if (exists) {
              // Success code
              //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
              element.empPhoto = this.employeePhotosImagePaths + element.Id + ".jpg";
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".png", (exists) => {
                if (exists) {
                  // Success code
                  element.empPhoto = this.employeePhotosImagePaths + element.Id + ".png";
                } else {
                  // Fail code - use default
                  element.empPhoto = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });

          this.zipReps.push(element);

        }

      }
      else {
        this.useZipContent = true;
        this.displayLoginFailure = true;

      }
    })
  }

  HelpMeFindThis() {

  }

  SubmitFromVerifyScreen() {
    this.HideFailureAlert();

    //they are a new company to harrells and they provided their company name 
    //submit it but with they new company name info 
    this.myHarrellsService.stage = "ProcessingRequest";

    this.selectedZipRep = this.verifiedRep

    //check to see if the image exists
    //display the rep for them to call if needed
    this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.selectedZipRep.Id + ".jpg", (exists) => {
      if (exists) {
        // Success code
        this.selectedZipRep.empPhoto = this.employeePhotosImagePaths + this.selectedZipRep.Id + ".jpg";
      } else {
        // Fail code
        this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.selectedZipRep.Id + ".png", (exists) => {
          if (exists) {
            // Success code
            this.selectedZipRep.empPhoto = this.employeePhotosImagePaths + this.selectedZipRep.Id + ".png";
          } else {
            // Fail code - use default
            this.selectedZipRep.empPhoto = this.baseImagePaths + "harrellsh.png"
          }
        })
      }
    });

    this.myHarrellsService.LogNotificationEntry('', this.companyName, this.customerId, this.email, this.phone, this.verifiedRep.RepId, this.title, this.name).subscribe((data: any) => {
    })


    if (!this.verifiedRep.RepId || this.verifiedRep.RepId == "" || this.verifiedRep.RepId == 0) {
      //get the deafault rep id for the company (this is the rep in the customer record)
      this.myHarrellsService.GetCustomerByCustNmbr(this.customerId).subscribe((data: any) => {
        if (data.length > 0) {
          if (data.length > 0) {
            this.verifiedRep.RepId = data[0].RepId;
            this.myHarrellsService.CreateUserCompanyAssociation(this.email, this.customerId, 'Customer Info Complete', this.verifiedRep.RepId).subscribe((data: any) => {
            })
          }
        }
      })
    }
    else {
      this.myHarrellsService.CreateUserCompanyAssociation(this.email, this.customerId, 'Customer Info Complete', this.verifiedRep.RepId).subscribe((data: any) => {
      })
    }

  }


  SubmitZipCode() {
    this.HideFailureAlert();
    if (this.selectedZipCustNmbr == "") {
      this.failureText = "You must validate a zip code AND select your company name from the customer list to continue.  Please validate your entries and try again.'";
      this.displayLoginFailure = true;
    }
    else if (this.selectedZipCustNmbr == "99999" && this.manualCompanyNameEntered.trim() == "") {
      //they are a new company to harrells but they did not provide their company name
      //stay on this screen but display the input for the user to key in their company name
      this.failureText = "Please provide your company name to proceed.";
      this.displayLoginFailure = true;
    }
    else if (this.selectedZipCustNmbr == "99999" && this.manualCompanyNameEntered.trim() != "") {
      //they are a new company to harrells and they provided their company name 
      //submit it but with they new company name info 
      this.myHarrellsService.stage = "ProcessingRequest";

      //check to see if the image exists
      //display the rep for them to call if needed
      this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.selectedZipRep.Id + ".jpg", (exists) => {
        if (exists) {
          // Success code
          this.selectedZipRep.empPhoto = this.employeePhotosImagePaths + this.selectedZipRep.Id + ".jpg";
        } else {
          // Fail code
          this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.selectedZipRep.Id + ".png", (exists) => {
            if (exists) {
              // Success code
              this.selectedZipRep.empPhoto = this.employeePhotosImagePaths + this.selectedZipRep.Id + ".png";
            } else {
              // Fail code - use default
              this.selectedZipRep.empPhoto = this.baseImagePaths + "harrellsh.png"
            }
          })
        }
      });

      //LogNotificationEntry UpdateUsersRegistrationStatusForCompanyNoMatch and redraw the screen showing it worked 

      this.myHarrellsService.LogNotificationEntry(this.manualCompanyNameEntered, this.manualCompanyNameEntered, '', this.email, this.phone, this.selectedZipRep.RepId, this.title, this.name).subscribe((data: any) => {
        let sss = "";
      })

      this.myHarrellsService.UpdateUsersRegistrationStatusForCompanyNoMatch(this.email, this.manualCompanyNameEntered).subscribe((data: any) => {
      })

    }
    else {
      //move to the customer info screen and display the selected rep and customer name
      this.customerId = this.selectedZipCustNmbr;
      this.VerifyClicked();
      this.myHarrellsService.stage = 'CustomerInfo';

    }
  }

  CancelZipCode() {
    this.myHarrellsService.stage = "CustomerInfo";
  }

  SelectedZipRep(rep: any) {
    //show the repo selected AND the dropdown of all customers this rep services 
    this.selectedZipRep = rep;
    this.zipRepSelected = true;

    this.myHarrellsService.GetCustomersForZipRep(this.selectedZipRep.RepId, this.zipCode).subscribe((data: any) => {

      this.zipReps = data;
      this.zipReps.unshift({ Name: "My company is not in the list", CustomerNumber: "99999" });
      this.zipReps.unshift({ Name: "--Select--", CustomerNumber: "" });
    })
  }


}
